import { EOrderStatus } from 'types/api';
import { EDispatcherOrderCardActionsBtnKeys } from '../types';
import { ICardActionBtn } from './types';
import { BUTTON_COLOR_SETS, EButtonColorTypes } from 'components/CustomButton';

export const ORDER_CARD_HEIGHT = 132;

// ! Card Action Buttons
export const CARD_ACTIONS_BUTTONS: Record<EDispatcherOrderCardActionsBtnKeys, ICardActionBtn> = {
	can_transition_to_new: {
		// aka old "process" action
		key: EDispatcherOrderCardActionsBtnKeys.CAN_TRANSITION_TO_NEW,
		colorTokens: BUTTON_COLOR_SETS[EButtonColorTypes.btn_green],
	},
	can_prepare: {
		// aka old "process" action
		key: EDispatcherOrderCardActionsBtnKeys.CAN_PREPARE,
		colorTokens: BUTTON_COLOR_SETS[EButtonColorTypes.btn_green],
	},
	can_mark_as_ready: {
		key: EDispatcherOrderCardActionsBtnKeys.CAN_MARK_AS_READY,
		colorTokens: BUTTON_COLOR_SETS[EButtonColorTypes.btn_cyan],
	},
	can_complete: {
		key: EDispatcherOrderCardActionsBtnKeys.CAN_COMPLETE,
		colorTokens: BUTTON_COLOR_SETS[EButtonColorTypes.btn_green],
	},
	can_cancel: {
		key: EDispatcherOrderCardActionsBtnKeys.CAN_CANCEL,
		danger: true,
		colorTokens: BUTTON_COLOR_SETS[EButtonColorTypes.btn_danger],
	},
	can_reject: {
		key: EDispatcherOrderCardActionsBtnKeys.CAN_REJECT,
		danger: true,
		colorTokens: BUTTON_COLOR_SETS[EButtonColorTypes.btn_danger],
	},
};
export const CARD_ACTIONS_BUTTONS_VALUES = Object.values(CARD_ACTIONS_BUTTONS);

export const ACTION_TO_STATUS: Record<EDispatcherOrderCardActionsBtnKeys, EOrderStatus> = {
	[EDispatcherOrderCardActionsBtnKeys.CAN_TRANSITION_TO_NEW]: EOrderStatus.NEW,
	[EDispatcherOrderCardActionsBtnKeys.CAN_PREPARE]: EOrderStatus.PREPARING,
	[EDispatcherOrderCardActionsBtnKeys.CAN_MARK_AS_READY]: EOrderStatus.READY,
	[EDispatcherOrderCardActionsBtnKeys.CAN_COMPLETE]: EOrderStatus.COMPLETED,
	[EDispatcherOrderCardActionsBtnKeys.CAN_CANCEL]: EOrderStatus.CANCELLED,
	[EDispatcherOrderCardActionsBtnKeys.CAN_REJECT]: EOrderStatus.REJECTED,
};
